import { Component, Inject, OnDestroy, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ConfirmDialogComponent, Envelope, EnvelopeOrder, EnvelopeRepositoryService } from 'reg-hub-common';
import { BehaviorSubject, Subject, takeUntil } from 'rxjs';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'app-envelope-orders-popup',
    templateUrl: './envelope-orders-popup.component.html',
    styleUrls: ['./envelope-orders-popup.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EnvelopeOrdersPopupComponent implements OnInit, OnDestroy {
  private readonly transloco = inject(TranslocoService);
  filterOrderID = '';
  displayedColumns = [
    "reference",
    "orderID",
    "type",
    "order-status",
    "external-status",
    "view",
    "delete"
  ];

  envelope!: Envelope;
  envelopeOrders: EnvelopeOrder[] = [];
  envelopeOrders$ = new BehaviorSubject<EnvelopeOrder[]>([]);

  private onDestroy$ = new Subject<void>();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: Envelope,
    private envelopeService: EnvelopeRepositoryService,
    private router: Router,
    private dialog: MatDialog) {
    this.envelope = data;
  }

  ngOnInit(): void {
    this.loadEnvelopeOrders();
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  // The envelopes list is fetched without its orders, so load them for this envelope only when the popup opens
  private loadEnvelopeOrders() {
    this.envelopeService.getEnvelope(this.envelope.id)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(envelope => {
        this.envelopeOrders = envelope?.envelopeOrders ?? [];
        this.onFilterOrder();
      });
  }

  viewOrder(eo: EnvelopeOrder) {
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['orders', eo.orderID])
    );

    window.open(url, '_blank');
  }

  onDelete(eo: EnvelopeOrder) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: this.transloco.translate('envelopeOrdersPopup.confirmRemoveOrderFromTheEnvelope', { orderReferenceNumber: eo.orderReferenceNumber }),
        confirmationPrompt: "",
        positiveResponseLabel: this.transloco.translate('envelopeOrdersPopup.doIt'),
        negativeResponseLabel: this.transloco.translate('envelopeOrdersPopup.actuallyNo')
      },
      minWidth: '800px'
    });

    dialogRef.afterClosed().subscribe(val => {
      if (val === true) {
        this.envelopeService.removeOrderFromEnvelope(eo.envelopeID, eo.orderID)
          .subscribe(() => {
            this.loadEnvelopeOrders();
            this.envelopeService.refresh();
          });
      }
    });
  }

  onFilterOrder() {
    if(this.filterOrderID) {
      this.envelopeOrders$.next(this.envelopeOrders.filter(eo => eo.orderID.toUpperCase().replaceAll('-', '').includes(this.filterOrderID.toUpperCase().replaceAll('-', ''))));
    } else {
      this.envelopeOrders$.next(this.envelopeOrders);
    }
  }
}
